import httpClient from "../http/http-client";
import { IReportAction } from './report-action.model';

export default class ReportActionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getReportActions(queryStringReportPeriodId?: string, queryStringUserId?: string): Promise<IReportAction[]> {
    return this.http.get(`report-action?reportPeriodId=${queryStringReportPeriodId}${queryStringUserId ? `${queryStringUserId}` : ''}`)
      .then(response => {
        return response.data.rows;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getReportActionsWithPagination(reportPeriodId: string, queryStringUserId: string, page: number, perPage: number = 10): Promise<{ count: number, rows: IReportAction[] }> {
    return this.http.get(`report-action?reportPeriodId=${reportPeriodId}${queryStringUserId}&page=${page}&perPage=${perPage}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async checkIfActionReportOrReduction(actionId: string): Promise<any> {
    return this.http.get(`report-action/report-or-reduction/${actionId}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  async getOneAction(actionId: string): Promise<IReportAction> {
    return this.http.get(`report-action/${actionId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async completeAction(actionId: string): Promise<any> {
    return this.http.post(`report-action/${actionId}/complete`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async completeActions(groupId: string, reportPeriodId: string): Promise<any> {
    return this.http.post(`report-action/complete-all?groupId=${groupId}&reportPeriodId=${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getPriorValue(actionId: string): Promise<{ available: boolean, quantity?: number, unitName?: string | null, periodLabel?: string }> {
    return this.http.get(`report-action/${actionId}/prior-value`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getBulkAssignScope(actionId: string): Promise<{ count: number }> {
    return this.http.get(`report-action/${actionId}/bulk-assign-scope`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async updateActionStatus(actionId: string, status: string | null, reason?: string): Promise<any> {
    return this.http.post(`report-action/${actionId}/status`, { status, reason })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async reassignAllActions(reportPeriodId: string, fromUserId: string, toUserId: string | null): Promise<{ updated: number }> {
    return this.http.post(`report-action/reassign-all`, { reportPeriodId, fromUserId, toUserId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async assignUserToActions(actionId: string, userId: string, assignToAllActions: boolean,): Promise<any> {
    return this.http.post(`report-action/assign-user?assignToAllActions=${assignToAllActions}`, { userId: userId, reportActionId: actionId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }
}